import type { PropsWithChildren } from "react";

import type { BaseCellProps } from "@similarweb/pro-logic-components";

import { DATA_AUTOMATION_VALUE } from "./const";
import { StyledBaseCell } from "./styles";
import { colorsPalettes } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";

/* TODO move to pro-logic-components cells */
const RatingCell = ({ children, dataAutomation }: PropsWithChildren<Pick<BaseCellProps, "dataAutomation">>) => {
    return (
        <StyledBaseCell dataAutomation={dataAutomation ?? DATA_AUTOMATION_VALUE}>
            {children}
            <SWReactIcons
                iconName="star"
                size="14px"
                iconColor={colorsPalettes.yellow[400]}
            />
        </StyledBaseCell>
    );
};

export default RatingCell;
